import { type AgentLicenseData } from "@src/appV2/Agents/types";
import { useGetQualificationDisplayLabels } from "@src/appV2/Qualifications/api/useGetQualificationDisplayLabels";
import { ToggleButton } from "@src/appV2/redesign/system/ui-components";

import { FiltersToggleButtonGroup } from "../Filters/BottomSheet/ToggleButtonGroup";

const ALL_ROLES_FILTER_VALUE = "__ALL_ROLES__";

interface ShiftBlockQualificationFilterProps {
  value: string;
  onChange: (value: string) => void;
  agentLicenses: AgentLicenseData[];
}

export function ShiftBlockQualificationFilter(props: ShiftBlockQualificationFilterProps) {
  const { value, onChange, agentLicenses } = props;

  const uniqueQualifications = [
    ...new Map(agentLicenses.map((license) => [license.qualification, license])).values(),
  ];

  const { qualificationNameToDisplayLabelMap } = useGetQualificationDisplayLabels(
    uniqueQualifications.map((license) => license.qualification)
  );

  return (
    <FiltersToggleButtonGroup
      exclusive
      value={value}
      aria-label="Qualification Filter"
      onChange={(newValue) => {
        if (newValue !== undefined) {
          onChange(newValue);
        }
      }}
    >
      <ToggleButton
        value={ALL_ROLES_FILTER_VALUE}
        selected={value === ALL_ROLES_FILTER_VALUE}
        iconType={value === ALL_ROLES_FILTER_VALUE ? "checkmark" : undefined}
      >
        All Roles
      </ToggleButton>
      {uniqueQualifications.map((license) => (
        <ToggleButton
          key={license.qualification}
          value={license.qualification}
          selected={value === license.qualification}
          iconType={value === license.qualification ? "checkmark" : undefined}
        >
          {qualificationNameToDisplayLabelMap.get(license.qualification) ?? license.qualification}
        </ToggleButton>
      ))}
    </FiltersToggleButtonGroup>
  );
}
